import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-scene-player',
  templateUrl: './scene-player.component.html',
  styleUrls: ['./scene-player.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ]
})
export class ScenePlayerComponent {

  @Input() hasPrevious: boolean = false;
  @Input() hasNext: boolean = false;
  @Input() canRewind5s: boolean = false;

  @Input() currentIndex: number = 0;
  @Input() totalScenes: number = 0;

  @Output() onPrev = new EventEmitter<void>();
  @Output() onNext = new EventEmitter<void>();
  @Output() onReplay = new EventEmitter<void>();
  @Output() onRewind5s = new EventEmitter<void>();

}
